<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <EditCandidate />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import EditCandidate from "./components/EditCandidate";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    EditCandidate,
    // ProjectsTable,
  },
};
</script>
